import { ILayerItem } from "api/models";
import { convertArea, round } from "@turf/helpers";

export const generateTimelineItems = (data: any) => {
  const thisYear = new Date().getFullYear();
  const timeFrames: any = [];
  for (var i = 2013; i <= thisYear; i++) {
    timeFrames.push({
      year: i.toString(),
      nonDispatched: 0,
      demobilized: 0,
    });
  }
  for (const d of data) {
    const { year, status, count } = d;
    if (year >= 2013) {
      const frame = timeFrames[year - 2013];
      if (status === 2) {
        frame.nonDispatched = count;
      } else if (status === 3) {
        frame.demobilized = count;
      }
    }
  }
  timeFrames.reverse();
  return timeFrames
    .filter((s) => s.demobilized || s.nonDispatched)
    .map((s) => {
      const { year, nonDispatched, demobilized } = s;
      return {
        text: year,
        value: year,
        data: {
          nonDispatched,
          demobilized,
        },
      } as ILayerItem;
    });
};

export const formatFireSize = (size: string): string => {
  if (size === "-1") {
    return "0";
  }
  return size || "n/a";
};

export const processNumber = (preference: string, origUnit: string, amount: number, decPlaces: number = 1): number => {
  if(amount <= 0 || Number.isNaN(amount)) return amount;
  //wrap all numbers in this utility function to make sure 
  //each number is processed as needed
  if(preference == "imperial"){
    return amount;
  }
  switch(origUnit){
    case 'acres': //turf.js was accurate for this one
      return round(convertArea(amount, 'acres', 'hectares'), decPlaces)
    case 'miles': //turf.js was inaccurate, switching to regular conversion
      return round(amount * 1.609, decPlaces)
    default:
      return amount;
  }
  //only returns this if a case hasn't been covered. easy bug hunting
  return -1;
}

export const uploadMetricNumber = (origUnit: string, amount: number, decPlaces: number = 1): number => {
  //only use this if someone is making post requests
  //with the metric preference set
  //because their numbers will be in metric
  //and need to be converted for the database
  switch(origUnit){
    case 'acres':
      return round(convertArea(amount, 'hectares', 'acres', decPlaces))
    case 'miles':
      return round(amount / 1.609, decPlaces)
    default:
      return amount;
  }
}